var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.storyOutline.genFlag)?_c('el-button',{staticClass:"custom-button",attrs:{"size":_vm.$root.buttonSize,"type":"default","round":"","loading":_vm.isLoading,"disabled":_vm.isLoading},on:{"click":function($event){return _vm.handleOpen()}}},[_vm._v(_vm._s(_vm.$t('update_story_graph')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }